import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../_virtual/_rollupPluginBabelHelpers.js';
import { createGlobalStyle } from 'styled-components';
import theme from 'styled-theming';
import { normalize } from 'styled-normalize';
import { toolTipStyles } from '../ui/tooltip/styles.js';
import { reachTabStyles } from '../ui/tabs/styles.js';

var _templateObject;
const GlobalStyles = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  /** Use a better box model */\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  /** Allow for easy page layout */\n  html, body { min-height: 100%; }\n\n  html {\n    font-size: 62.5%;\n  }\n\n  /** Padding set with !important to prevent double scrollbar being added by plugin:\n   * https://github.com/theKashey/react-remove-scroll-bar/blob/master/src/component.tsx\n   * Haven't been able to identify why the padding is incorrectly calculated.\n  */\n  body {\n    color: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    padding: 0 !important;\n\n    &[dir='rtl'], [dir='rtl'] & {\n      font-family: ", ";\n      line-height: ", ";\n    }\n  }\n\n  ::selection {\n    ", "\n  }\n\n  a {\n    color: ", ";\n    transition: ", ";\n    \n    &:hover,\n    &:focus,\n    &:active {\n      text-decoration: none;\n      color: ", ";\n    }\n  }\n\n  p {\n    margin-top: 0;\n  }\n\n  :focus {\n    outline: none;\n  }\n\n  :focus-visible {\n    box-shadow: ", ";\n  }\n\n  /** 3rd party plugin styling */\n  ", "\n  ", "\n"])), normalize, _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.text;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.fontSizes.standard;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.fonts.body;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.lineHeights.body;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.rtlFonts.body;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.rtlLineHeights.body;
}, _ref7 => {
  let {
    theme: {
      colors
    }
  } = _ref7;
  return theme('mode', {
    light: "\n          background: ".concat(colors.primary.main, ";\n          color: ").concat(colors.primary.contrastText, ";\n        "),
    dark: "\n          background: ".concat(colors.primary.light, ";\n          color: ").concat(colors.primary.contrastTextLight, ";\n        ")
  });
}, _ref8 => {
  let {
    theme: {
      colors
    }
  } = _ref8;
  return theme('mode', {
    light: colors.primary.main,
    dark: colors.primary.light
  });
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.transitionsMs.default;
}, _ref10 => {
  let {
    theme: {
      colors
    }
  } = _ref10;
  return theme('mode', {
    light: colors.primary.dark,
    dark: colors.primary.main
  });
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.boxShadows.focus;
}, reachTabStyles, toolTipStyles);

export { GlobalStyles };
